import { Schema } from 'prosemirror-model';
import { addSuggestionMarks } from 'prosemirror-suggestion-mode';

// const INT_LINK_PREFIX = 'https://annote.com/ids=';

const schema = new Schema({
  nodes: {
    doc: { content: 'block+' },
    paragraph: {
      content: 'inline*',
      group: 'block',
      parseDOM: [{ tag: 'p' }],
      toDOM: () => ['p', 0],
    },
    text: { group: 'inline' },
    list_item: {
      content: 'paragraph block*',
      defining: true,
      parseDOM: [{ tag: 'li' }],
      toDOM: () => ['li', 0],
    },
    bullet_list: {
      content: 'list_item+',
      group: 'block',
      parseDOM: [{ tag: 'ul' }],
      toDOM: () => ['ul', 0],
    },
    ordered_list: {
      attrs: { order: { default: 1 } },
      content: 'list_item+',
      group: 'block',
      parseDOM: [
        {
          tag: 'ol',
          getAttrs(dom) {
            return { order: dom.hasAttribute('start') ? +(dom.getAttribute('start') ?? 1) : 1 };
          },
        },
      ],
      toDOM: (node) => ['ol', { start: node.attrs.order }, 0],
    },
    reference: {
      // Inline node for note references with optional text highlighting
      attrs: {
        noteId: {},
        noteName: { default: '' },
        noteType: { default: 'takeaway' },
        text: { default: '' },
        textStart: { default: null },
        textEnd: { default: null },
      },
      inline: true,
      group: 'inline',
      atom: true, // Treated as a single unit
      toDOM(node) {
        // For atomic nodes, just return the element without content
        // The NodeView will handle the actual rendering
        return [
          'span',
          {
            class: 'prosemirror-reference-node',
            'data-note-id': node.attrs.noteId,
            'data-note-name': node.attrs.noteName || '',
            'data-note-type': node.attrs.noteType || 'takeaway',
            'data-text': node.attrs.text || '',
            'data-text-start': node.attrs.textStart != null ? String(node.attrs.textStart) : '',
            'data-text-end': node.attrs.textEnd != null ? String(node.attrs.textEnd) : '',
          },
        ];
      },
      parseDOM: [
        {
          tag: 'span.prosemirror-reference-node',
          getAttrs(dom) {
            const textStartAttr = dom.getAttribute('data-text-start');
            const textEndAttr = dom.getAttribute('data-text-end');
            return {
              noteId: dom.getAttribute('data-note-id') || '',
              noteName: dom.getAttribute('data-note-name') || '',
              noteType: (dom.getAttribute('data-note-type') || 'takeaway') as 'takeaway' | 'source' | 'annote',
              text: dom.getAttribute('data-text') || '',
              textStart: textStartAttr ? parseInt(textStartAttr, 10) : null,
              textEnd: textEndAttr ? parseInt(textEndAttr, 10) : null,
            };
          },
        },
      ],
    },
  },
  marks: addSuggestionMarks({
    strong: {
      parseDOM: [{ tag: 'strong' }],
      toDOM: () => ['strong', 0],
    },
    em: {
      parseDOM: [{ tag: 'i' }],
      toDOM: () => ['i', 0],
    },
    link: {
      // TODO - do we want this?  Not sure.
      attrs: {
        href: {},
        internal: { default: false }, // 'internal' marks whether it's an internal vs external link
      },
      toDOM(node) {
        return [
          'a',
          {
            href: node.attrs.href,
            class: node.attrs.internal ? 'internal-link' : '',
          },
          0,
        ];
      },
      parseDOM: [
        {
          tag: 'a[href]',
          getAttrs(dom) {
            return {
              href: dom.getAttribute('href') || '',
              title: dom.getAttribute('title') || '',
              internal: dom.classList.contains('internal-link'),
            };
          },
        },
      ],
    },
  }),
});

export { schema };
